import jobPostRoutes from './jobPostRoutes';
import deactivationRoutes from './deactivationRoutes';
import seekersDashboardRoutes from './seekersDashboardRoutes';
import exploreRoutes from './exploreRoutes';
import registrationRoutes from './registrationRoutes';
import bhBenefitsRoutes from './bhBenefitsRoutes';
import searchRoutes from './searchRoutes';
import upgradeRoutes from './upgradeRoutes';
import shareJobsRoutes from './shareJobsRoutes';
import interviewRequestRoutes from './interviewRequestRoutes';
import bookingsRoutes from './bookingsRoutes';
import ratingsRoutes from './ratingsRoutes';
import corporateOnboardingRoutes from './corporateOnboardingRoutes';
import backupCareRoutes from './backupCareRoutes';
import onboardingSeekerRoutes from './onboardingSeekerRoutes';
import messagesNewRoutes from './messagesNewRoutes';

const seekerRoutes = [
  ...jobPostRoutes,
  ...seekersDashboardRoutes,
  ...deactivationRoutes,
  ...searchRoutes,
  ...bhBenefitsRoutes,
  ...upgradeRoutes,
  ...interviewRequestRoutes,
  ...exploreRoutes,
  ...registrationRoutes,
  ...onboardingSeekerRoutes,
  ...shareJobsRoutes,
  ...bookingsRoutes,
  ...ratingsRoutes,
  ...corporateOnboardingRoutes,
  ...backupCareRoutes,
  ...messagesNewRoutes,
];

export default seekerRoutes;
